import React from 'react';

export default function Base(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            width={211.791}
            height={220.419}
            style={{
                shapeRendering: "geometricPrecision",
                textRendering: "geometricPrecision",
                imageRendering: "optimizeQuality",
                fillRule: "evenodd",
                clipRule: "evenodd",
            }}
            viewBox="0 0 841 876"
            className={props.className}
        >
            <defs>
                <style>
                {`
                    #c-${props.id} .fil0 {fill:#${props.base};fill-rule:nonzero}
                    #c-${props.id} .fil1 {fill:#${props.sleeve};fill-rule:nonzero}
                    #c-${props.id} .fil2 {fill:#252422;fill-rule:nonzero}
                `}
                </style>
            </defs>
            <g id={`c-${props.id}`}>
                <g>
                    <path className="fil0" d="M497 38c-18,11 -48,24 -91,22 -39,-2 -67,-13 -84,-23 12,52 45,86 87,86 41,0 76,-35 88,-85z"/>
                    <path className="fil2" d="M140 122c-34,87 -45,148 -66,263l-6 33c-21,116 -38,240 -42,277l84 14 73 -419c0,-17 0,-34 -2,-48 -2,-12 -5,-23 -7,-33 -1,-1 -1,-3 -1,-4 -10,-40 -23,-66 -33,-82z"/>
                    <path className="fil2" d="M671 200c0,2 0,4 -1,5l0 0c-2,8 -4,16 -6,25 -2,17 -3,39 -3,61l70 409 83 -14c-7,-34 -26,-134 -43,-237 -24,-144 -40,-217 -77,-316 -7,13 -15,33 -23,66z"/>
                    <path className="fil0" d="M204 837c26,4 116,16 209,16 123,0 198,-11 225,-16l0 -538c-1,-25 0,-59 4,-83l0 0c11,-68 26,-97 37,-109 -7,-8 -17,-17 -26,-23 -13,-9 -42,-23 -56,-28 -14,-6 -41,-19 -74,-28 -11,69 -57,119 -114,119 -57,0 -102,-48 -113,-118 -18,4 -28,9 -39,13l-10 3c-16,5 -48,20 -62,29 -14,9 -26,16 -33,24 13,15 33,47 46,111 1,5 2,11 3,17 0,2 1,3 1,5l0 0c3,23 3,52 2,73 0,1 0,2 -1,3l0 529z"/>
                </g>
                <path className="fil1" d="M204 837c26,4 116,16 209,16 123,0 198,-11 225,-16l0 -538c-1,-25 0,-59 4,-83l0 0c11,-68 26,-97 37,-109 -7,-8 -17,-17 -26,-23 -13,-9 -42,-23 -56,-28 -14,-6 -41,-19 -74,-28 -11,69 -57,119 -114,119 -57,0 -102,-48 -113,-118 -18,4 -28,9 -39,13l-10 3c-16,5 -48,20 -62,29 -14,9 -26,16 -33,24 13,15 33,47 46,111 1,5 2,11 3,17 0,2 1,3 1,5l0 0c3,23 3,52 2,73 0,1 0,2 -1,3l0 529zm467 -636c0,2 0,4 -1,5l0 0c-2,8 -4,16 -6,25 -2,17 -3,39 -3,61l70 409 83 -14c-7,-34 -26,-134 -43,-237 -24,-144 -40,-217 -77,-316 -7,13 -15,33 -23,66zm-531 -78c-34,87 -45,148 -66,263l-6 33c-21,116 -38,240 -42,277l84 14 73 -419c0,-17 0,-34 -2,-48 -2,-12 -5,-23 -7,-33 -1,-1 -1,-3 -1,-4 -10,-40 -23,-66 -33,-82zm358 -84c-18,11 -48,24 -91,22 -39,-2 -67,-13 -84,-23 12,52 45,86 87,86 41,0 76,-35 88,-85zm-181 -33l1 0 0 1c3,3 33,29 90,31 65,3 93,-30 94,-31l5 -5 7 1c41,9 76,26 93,33 15,6 46,21 60,30 17,12 39,35 43,45 43,109 59,183 85,336 21,126 45,247 45,248l2 12 -127 21 -49 -295 0 424 -11 2c-3,1 -86,18 -241,18 -116,0 -221,-17 -222,-18l-8 -2 0 -426 -54 305 -129 -21 1 -11c0,-1 18,-150 44,-289l6 -33c22,-122 34,-183 72,-280 7,-18 24,-30 50,-47 17,-11 49,-25 67,-31l10 -3c15,-5 27,-11 57,-17l6 -1 4 4z"/>
            </g>
        </svg>
    );
}
